import { setInterval } from 'core-js/internals/schedulers-fix'

export const strict = false

export const state = () => ({
  stack: [],
  counter: 0,
  interval: null
})
export const getters = {
  events: state =>
    state.stack.reduce((c, n) => {
      const seconds = (c.seconds || n.seconds) - state.counter
      const [dd, hh, mm, ss] = [
        Math.floor(seconds / (3600 * 24)).toString(), // days
        Math.floor((seconds % (3600 * 24)) / 3600) // hours
          .toString()
          .padStart(2, '0'),
        Math.floor((seconds % 3600) / 60) // minutes
          .toString()
          .padStart(2, '0'),
        Math.floor(seconds % 60) // seconds
          .toString()
          .padStart(2, '0')
      ]
      return { [n.id]: { dd, hh, mm, ss }, ...c }
    }, {}),
  isTimerRunning: state => !!state.interval,
  expiredTimers: () => {
    return JSON.parse(window.sessionStorage.getItem('expiredTimers')) || []
  }
}
export const mutations = {
  REPLACE_STACK(state, stack) {
    state.stack = stack
  },
  APPEND_STACK(state, deadline) {
    state.stack.push(deadline)
  },
  SET_INTERVAL(state, { cb, duration }) {
    state.interval = setInterval(cb, duration)
  },
  CLEAR_INTERVAL(state) {
    clearInterval(state.interval)
  },
  CLEAR_COUNTER(state) {
    state.counter = 0
  },
  SET_EXPIRED_TIMERS(state, expiredTimers) {
    window.sessionStorage.setItem(
      'expiredTimers',
      JSON.stringify(expiredTimers)
    )
  }
}
export const actions = {
  addEvent({ commit, dispatch, getters, state }, { deadline }) {
    if (getters.expiredTimers.find(id => id === deadline.id)) {
      return
    }
    if (deadline.id)
      if (deadline.isDateTime) {
        // fetch seconds from API
        dispatch('getSecondsTil', deadline.dateTime).then(({ data }) =>
          commit('APPEND_STACK', { ...deadline, seconds: data.data.seconds })
        )
      } else {
        commit('APPEND_STACK', deadline)
      }

    if (!getters.isTimerRunning) {
      commit('SET_INTERVAL', {
        cb: () => dispatch('tick'),
        duration: 1000
      })
    }
  },
  getSecondsTil({ rootState }, date) {
    return this.$axios.get(
      rootState.config.salesApi + '/util/seconds/to?date=' + date
    )
  },
  tick({ commit, getters, state }) {
    const now = state.counter
    // IF checks to make sure state is populated before running tick function
    if (state.stack.length) {
      // scan for deadlines that have been met
      const metDeadlines = state.stack.filter(t => t.seconds <= now)
      // execute their callbacks if we have any
      if (metDeadlines.length) {
        metDeadlines.forEach(t => {
          if (t.permanent) {
            getters.expiredTimers.push(t.id)
            commit('SET_EXPIRED_TIMERS', getters.expiredTimers)
          }
          t.callback()
        })
        commit(
          'REPLACE_STACK',
          state.stack.filter(t => t.seconds > now)
        )
      }
      state.counter++
      // turn off timer once the stack is clear as we have no timers to execute on
      if (!state.stack.length) clearInterval(state.interval)
    } else {
      //  If STATE is not populated tick still needs to run, but delay it for 5 seconds so the state can catch up
      setTimeout(() => {
        const metDeadlines = state.stack.filter(t => t.seconds <= now)
        // execute their callbacks if we have any
        if (metDeadlines.length) {
          metDeadlines.forEach(t => t.callback())
          commit(
            'REPLACE_STACK',
            state.stack.filter(t => t.seconds > now)
          )
        }
        state.counter++
      }, 5000)
    }
  },
  clearCounter({ commit }) {
    commit('CLEAR_COUNTER')
  }
}
// e.g. dispatch('timer/addEvent', { id: '9829292', deadline: { seconds: 10, isDateTime: false, dateTime: null }, callback: () => console.log('deadline met') })
// e.g. dispatch('timer/addEvent', { id: '9829293', deadline: { seconds: 0, isDateTime: true, dateTime: '2020-01-01T00:00:00.000Z' }, callback: () => console.log('deadline met') })
